import { Storage } from './storage';

export {
  Storage,
  createStorage,
  type StorageOptions,
  type StorageConstructorOptions,
} from './storage';
export {
  JotaiStorageWrapper,
  createJotaiStorage,
  createWindowIsolatedStorage,
} from './jotaiStorage';
export { getWindowId, resetWindowId, getWindowScopedKey } from './windowId';
export { safeStorage, type StorageType } from './safeStorage';

export const storage = new Storage();
